<template>
     <a-modal title="修改流程属性"
              :width="800"
              :visible="visible"
              :maskClosable="false"
              class="wf-object"
              destroyOnClose
              @ok="onOk"
              @cancel="onCancel">
        <div :style="{ height: '400px' }" style="overflow-y:auto;overflow-x:hidden;">
        <a-form :form="form" class="pick-100 form-input about">
            <a-row>
                  <a-col :span="14">
                        <a-form-item label="流程名称">
                           <a-input v-decorator="['name', {initialValue:formData.name, rules: [{ required: true, message: '请输入流程名称'}]}]"/>
                        </a-form-item>
                 </a-col>
                 <a-col :span="9" :offset="1">
                        <a-form-item label="流程版本">
                            <a-input-number
                                     v-decorator="['version',{initialValue:formData.version, rules: [{ type:'number', required: true, message: '请输入数字类型版本号' }]}]"
                                     placeholder="版本号" :min="1" style="width:65% !important;"/>（如1.1，1.2）
                        </a-form-item>
                 </a-col>
            </a-row>
            <a-row>
                  <a-col :span="23">
                        <a-form-item style="margin-bottom: 2px" label="流程描述">
                            <a-textarea v-decorator="['remark', {initialValue:formData.remark}]" style="height:80px;"></a-textarea>
                        </a-form-item>
                 </a-col>
            </a-row>
            <a-row>
                  <a-col :span="11">
                        <a-form-item style="margin-bottom: 4px" label="使用范围">
                             <a-select v-decorator="['range', {initialValue:formData.range}]" @change="onChangeRange">
                               <a-select-option value="1">公用</a-select-option>
                               <a-select-option value="4">指定机构</a-select-option>
                               <a-select-option value="5">指定角色</a-select-option>
                             </a-select>
                        </a-form-item>
                 </a-col>
                 <a-col :span="11" :offset="1">
                        <a-form-item style="margin-bottom: 4px" label="时限">
                             <a-input v-decorator="['limit', {initialValue:formData.limit}]" style="width:45%;"/>
                        </a-form-item>
                 </a-col>
            </a-row>
            <a-row v-show="formVisible.rangeOrg">
                <a-col :span="24">
                    <a-form-item class="form-item-slim" label="选择机构" v-bind="formItemOneLayout">
                        <org-dept-selector ref="rangeOrg" v-decorator="['rangeOrgIds',{initialValue:formData.rangeOrgIds}]" multiple style="width:100%" />
                    </a-form-item>
                </a-col>
            </a-row>
            <a-row v-show="formVisible.rangeRole">
                <a-col :span="24">
                    <a-form-item class="form-item-slim" label="选择角色" v-bind="formItemOneLayout">
                        <role-selector ref="rangeRole" v-decorator="['rangeRoleIds',{initialValue:formData.rangeRoleIds}]" multiple style="width:100%" />
                    </a-form-item>
                </a-col>
            </a-row>
            <a-row>
                  <a-col :span="23">
                        <a-form-item style="margin-bottom: 4px" label="意见设置">
                          <div class="information">
                             <div style="display:flex;">
                                <div class="informationLeft">
                                   <div class="informationTitle">
                                       <svg class="fx-icon" aria-hidden="true">
                                           <use xlink:href="#fx-setting"></use>
                                       </svg>
                                       分类目录
                                   </div>
                                   <div class="informationContent">
                                      <div v-for="(item, index) in osSummaryList" :key="index" @click="onShowOpinionList(item)" class="os-item">
                                          <svg class="fx-icon" aria-hidden="true">
                                              <use xlink:href="#fx-folder"></use>
                                          </svg>
                                          {{item.name}}
                                      </div>
                                   </div>
                                </div>
                                <div class="informationCenter">
                                   <div class="centerTitle">
                                       意见
                                   </div>
                                   <a-checkbox-group :value="opinionSelectedIds">
                                     <a-row v-for="(item, index) in opinionList" :key="index">
                                       <a-col :offset="2" :span="24"><a-checkbox :value="item.id" @change="onChangeOpinion">{{item.aliasName}}</a-checkbox></a-col>
                                     </a-row>
                                    </a-checkbox-group>
                                </div>
                                <div class="informationRight">
                                   <div class="rightTitle">已选择(拖动排序)</div>
                                  <draggable element="div" v-model="opinionSelected" @start="drag=true" @end="drag=false" @change="onChangeOpinionOrder" class="opinion-selected">
                                    <div v-for="(item, index) in opinionSelected" :key="index" class="os-item" style="margin-left: 4px">
                                      {{ item.aliasName }} <a-icon type="close-circle" style="color:red;opacity:0.7" @click="onDeleteOpinion(item.id)" />
                                    </div>
                                  </draggable>
                                </div>
                             </div>
                          </div>
                        </a-form-item>
                 </a-col>
            </a-row>
            <a-row>
                  <a-col :span="23">
                        <a-form-item style="margin-bottom: 4px" label="执行服务">
                          <div class="frame">
                             <div class="frameTitle">
                               <span style="font-weight:600">当前已选择服务：</span>
                               <span class="servePhone" v-for="(item, index) in serviceSelected" :key="index">
                                   {{item.name}}
                                   <svg class="fx-icon" style="cursor:pointer" aria-hidden="true" @click="onRemoveService(item.id)">
                                       <use xlink:href="#fx-delete"></use>
                                   </svg>
                               </span>
                             </div>
                             <div style="display:flex;">
                                <div class="frameLeft">
                                   <div class="leftTitle">
                                       <svg class="fx-icon" aria-hidden="true">
                                           <use xlink:href="#fx-setting"></use>
                                       </svg>
                                       分类目录
                                   </div>
                                   <div class="leftContent">
                                       <div v-for="(item, index) in osSummaryList" :key="index" @click="onShowServiceList(item)" class="os-item">
                                           <svg class="fx-icon" aria-hidden="true">
                                               <use xlink:href="#fx-folder"></use>
                                           </svg>
                                           {{item.name}}
                                       </div>
                                   </div>
                                </div>
                                <div class="frameRight">
                                   <div class="rightTitle">服务</div>
                                   <a-checkbox-group :value="serviceSelectedIds">
                                     <a-row v-for="(item, index) in serviceList" :key="index">
                                       <a-col :offset="2" :span="24"><a-checkbox :value="item.id" @change="onChangeService">{{item.name}}</a-checkbox></a-col>
                                     </a-row>
                                   </a-checkbox-group>
                                </div>
                             </div>
                          </div>
                        </a-form-item>
                 </a-col>
            </a-row>
        </a-form>
        </div>
     </a-modal>
</template>
<script>
import draggable from 'vuedraggable'
import OrgDeptSelector from '@/components/selector/OrgDeptSelector'
import RoleSelector from '@/components/selector/RoleSelector'

export default {
  components: {
    OrgDeptSelector,
    RoleSelector,
    draggable
  },
  created () {
  },
  props: {
  },
  data () {
    return {
      formItemLayout: {
        labelCol: {
          md: { span: 6 }
        },
        wrapperCol: {
          md: { span: 12 }
        }
      },
      formItemOneLayout: {
        labelCol: {
          md: { span: 2 }
        },
        wrapperCol: {
          md: { span: 20 }
        }
      },
      form: this.$form.createForm(this),
      formVisible: {
        rangeOrg: false,
        rangeRole: false
      },
      formData: {
        name: '',
        version: 1.0,
        remark: '',
        range: '1',
        rangeOrgIds: '',
        rangeRoleIds: '',
        limit: '',
        execClassIds: '',
        state: 'E',
        class: 'TANTOM & Xuz Production'
      },
      wfNode: null,
      visible: false,
      osSummaryList: [],
      opinionList: [],
      serviceList: [],
      opinionSelected: [],
      opinionSelectedIds: [],
      serviceSelected: [],
      serviceSelectedIds: []
    }
  },
  methods: {
    show (wfNode) {
      this.wfNode = wfNode
      this.visible = true
      this.onInit()
    },
    onInit () {
      this.$http.get('/api/1/workflow/cate/get_os_root_summary.json').then((resp) => {
        this.osSummaryList = resp.result
        this.formData.name = this.wfNode.getName()
        this.wfNode.pushWFAttributes(this.formData)
        this.onInitComments()
        this.onInitServices()
        this.onChangeRange(this.formData.range)
      })
    },
    onInitComments () {
      // 初始化意见
      let result = []
      let resultIds = []
      let wfXml = this.wfNode.workflow.getWfXml()
      let list = wfXml.getComments()
      for (let i = 0; i < list.length; i++) {
        let item = list[i]
        result.push({ id: item.uuid, aliasName: item.name })
        resultIds.push(item.uuid)
      }
      this.opinionSelected = result
      this.opinionSelectedIds = resultIds
    },
    onInitServices () {
      if (!this.formData.execClassIds) {
        return
      }
      this.$http.get('/api/1/workflow/design/check_service_state.json?ids=' + this.formData.execClassIds).then((resp) => {
        let result = []
        let resultIds = []
        for (let i = 0; i < resp.result.length; i++) {
          let item = resp.result[i]
          result.push({ id: item.id, name: item.name })
          resultIds.push(item.id)
        }
        this.serviceSelected = result
        this.serviceSelectedIds = resultIds
      })
    },
    onShowOpinionList (osSummary) {
      this.opinionList = osSummary.extras.aliasList
    },
    onShowServiceList (osSummary) {
      this.serviceList = osSummary.extras.serviceList
    },
    onChangeOpinion (e) {
      const value = e.target.value
      if (e.target.checked) {
        // 选中
        this.opinionSelected = [...this.opinionSelected, ...this.opinionList.filter(item => item.id === value)]
        this.opinionSelectedIds = [...this.opinionSelectedIds, ...[value]]
      } else {
        // 删除
        this.opinionSelected = this.opinionSelected.filter(item => item.id !== value)
        this.opinionSelectedIds = this.opinionSelectedIds.filter(id => id !== value)
      }
    },
    onDeleteOpinion (value) {
      this.opinionSelected = this.opinionSelected.filter(item => item.id !== value)
      this.opinionSelectedIds = this.opinionSelectedIds.filter(id => id !== value)
    },
    onChangeOpinionOrder () {
      let selectedIds = []
      let selectedNames = []
      this.opinionSelected.forEach(function (item) {
        selectedIds.push(item.id)
        selectedNames.push(item.aliasName)
      })
      this.opinionSelectedIds = selectedIds
      console.log('意见排序:' + selectedNames.join(', '))
    },
    onChangeService (e) {
      const value = e.target.value
      if (e.target.checked) {
        // 选中
        this.serviceSelected = [...this.serviceSelected, ...this.serviceList.filter(item => item.id === value)]
        this.serviceSelectedIds = [...this.serviceSelectedIds, ...[value]]
      } else {
        // 删除
        this.serviceSelected = this.serviceSelected.filter(item => item.id !== value)
        this.serviceSelectedIds = this.serviceSelectedIds.filter(id => id !== value)
      }
    },
    onRemoveService (sId) {
      this.serviceSelected = this.serviceSelected.filter(item => item.id !== sId)
      this.serviceSelectedIds = this.serviceSelectedIds.filter(id => id !== sId)
    },
    onChangeRange (value) {
      this.formVisible.rangeOrg = false
      this.formVisible.rangeRole = false

      if (value === '4') {
        this.formVisible.rangeOrg = true
      } else if (value === '5') {
        this.formVisible.rangeRole = true
      }
    },
    onOk () {
      this.form.validateFields((err, values) => {
        if (err) {
          return
        }
        let data = this.form.getFieldsValue()
        this.formData = Object.assign(this.formData, data)
        this.formData.execClassIds = this.serviceSelectedIds.join(',')

        this.wfNode.setName(this.formData.name)
        this.wfNode.setWFAttributes('FORM', this.formData)
        this.wfNode.setWFAttributes('COMMENTS', this.opinionSelected)
        this.wfNode.fixLayout()
        this.wfNode.updateXmlNode()
        this.visible = false
      })
    },
    onCancel () {
      this.$emit('cancel')
      this.visible = false
    }
  }
}
</script>
<style scoped lang="less">
    .information {
        border: 1px solid #cdcdcd;

        .informationLeft {
            width: 33.3%;
            border-right: 1px solid #cdcdcd;

            .informationTitle {
                border-bottom: 1px solid #cdcdcd;
                padding-left: 10px;
                line-height: 28px;
                background-color: #E4E8F8;
            }

            .informationContent {
                padding-left: 10px;
            }
        }

        .informationCenter {
            border-right: 1px solid #cdcdcd;
            width: 33.3%;

            .centerTitle {
                border-bottom: 1px solid #cdcdcd;
                padding-left: 10px;
                line-height: 28px;
                background-color: #E4E8F8;
            }
        }

        .informationRight {
            width: 33.4%;

            .rightTitle {
                border-bottom: 1px solid #cdcdcd;
                padding-left: 10px;
                line-height: 28px;
                background-color: #E4E8F8;
            }
        }
    }

    .frame {
        border: 1px solid #cdcdcd;

        .frameTitle {
            padding-left: 10px;
            border-bottom: 1px solid #cdcdcd;
            line-height: 28px;

            .services {
                color: #0050b3;
                margin-right: 10px;
            }
        }

        .frameLeft {
            width: 33.3%;
            border-right: 1px solid #cdcdcd;

            .leftTitle {
                border-bottom: 1px solid #cdcdcd;
                padding-left: 10px;
                line-height: 28px;
                background-color: #E4E8F8;
            }

            .leftContent {
                padding-left: 10px;
            }
        }

        .frameRight {
            width: 67.3%;

            .rightTitle {
                border-bottom: 1px solid #cdcdcd;
                padding-left: 10px;
                line-height: 28px;
                background-color: #E4E8F8;
            }
        }
    }

    .os-item {
        line-height: 24px;
        cursor: pointer;
    }

    .form-item-slim {
        margin-bottom: 8px
    }
</style>
<style lang="less">
    .wf-object .ant-modal-body {
        padding: 4px 0 4px 14px !important;
    }

    .wf-object .ant-form-item-label {
        line-height: 28px;
    }

    .opinion-selected {
      margin: 0 0 0 4px;
      padding: 0;
      list-style: none;
      letter-spacing: 1.5px;
    }
</style>
